<div class="flex flex-column p-1 m-1">
  <app-crud-table [title]="'MzTabResults'" [columns]="columns" [filterFields]="filterFields" [crudAdapter]="crudAdapter"></app-crud-table>
</div>
